import { head } from "lodash";
export function secondLast(arr) {
    return arr[arr.length - 2];
}
export function isSubset(smaller, larger) {
    return smaller.every(i => larger.includes(i));
}
export function startsWith(master, start) {
    for (let i = 0; i < start.length; i++) {
        if (master[i] !== start[i]) {
            return false;
        }
    }
    return true;
}
export function toMap(array, keyProducer) {
    return array.reduce((accumulator, currentValue) => {
        accumulator[keyProducer(currentValue)] = currentValue;
        return accumulator;
    }, {});
}
export function moveItem(array, fromIndex, toIndex) {
    if (fromIndex === toIndex)
        return array;
    const newArray = [...array];
    const target = newArray[fromIndex];
    const inc = toIndex < fromIndex ? -1 : 1;
    for (let i = fromIndex; i !== toIndex; i += inc) {
        newArray[i] = newArray[i + inc];
    }
    newArray[toIndex] = target;
    return newArray;
}
export function removeItemAtIndex(arr, index) {
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
}
export function unique(array) {
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
    return array.filter(onlyUnique);
}
export function uniqueBy(array, keyGetter) {
    const hash = array.reduce((acc, t) => {
        acc[keyGetter(t)] = t;
        return acc;
    }, {});
    return Object.values(hash);
}
export function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        }
        else {
            collection.push(item);
        }
    });
    return map;
}
export function equal(array1, array2) {
    return JSON.stringify(array1) === JSON.stringify(array2);
}
export function ensureArray(a) {
    return Array.isArray(a) ? a : [a];
}
export async function filterAsync(arr, callback) {
    const fail = Symbol();
    // @ts-ignore
    return (await Promise.all(arr.map(async (item) => (await callback(item)) ? item : fail))).filter(i => i !== fail);
}
export function repeat(count, producer) {
    const result = [];
    for (let i = 0; i < count; i++) {
        result.push(producer(i));
    }
    return result;
}
export function take(amount, t) {
    if (t === null) {
        return null;
    }
    if (amount > t.length) {
        return t;
    }
    return t.slice(0, amount);
}
export function drop(amount, t) {
    if (t === null) {
        return null;
    }
    if (amount > t.length) {
        return null;
    }
    return t.slice(amount);
}
export function replaceElement(array, t, predicate) {
    const index = array.findIndex(predicate);
    if (index === -1) {
        return false;
    }
    array[index] = t;
    return true;
}
class DefaultHeadAndTail {
    constructor(head, tail) {
        this.head = head;
        this.tail = tail;
    }
    advance() {
        const theHead = head(this.tail) ?? null;
        const theTail = tail(this.tail);
        return new DefaultHeadAndTail(theHead, theTail);
    }
}
export function headAndTail(array) {
    return new DefaultHeadAndTail(head(array) ?? null, tail(array));
}
export function dropLast(array) {
    if (array.length > 1) {
        return array.slice(0, array.length - 1);
    }
    return [];
}
export function last(array) {
    if (array.length === 0) {
        return null;
    }
    return array[array.length - 1];
}
export function first(array) {
    if (array.length === 0) {
        return null;
    }
    return array[0];
}
export function tail(array) {
    if (array.length < 2) {
        return [];
    }
    return array.filter((v, i) => i !== 0);
}
export function dropNulls(array) {
    return array.filter(v => v !== null);
}
export function findMandatory(array, predicate, message = "Did not find item in array") {
    const maybe = array.find(predicate);
    if (maybe) {
        return maybe;
    }
    throw new Error(message);
}
export function compare(left, right, comparableProducer = (t) => t) {
    let leftOnly = left.filter(aLeft => right.find(aRight => comparableProducer(aLeft) === comparableProducer(aRight)) === undefined);
    let rightOnly = right.filter(aRight => left.find(aLeft => comparableProducer(aLeft) === comparableProducer(aRight)) === undefined);
    let both = uniqueBy([...left, ...right], comparableProducer).filter(aBoth => leftOnly.indexOf(aBoth) === -1 && rightOnly.indexOf(aBoth) === -1);
    return { leftOnly, both, rightOnly };
}
